module.exports = __webpack_public_path__ + "static/media/concert7.cc81d09e.jpg";